type RenderFn = (value: string) => string;
type NeedleConfig = Record<string, RenderFn>;

export function createNeedleRenderer(needleConfig: NeedleConfig) {
  return (text: string): string => {
    let result = text;

    for (const [needle, renderFn] of Object.entries(needleConfig)) {
      const regex = new RegExp(`<${needle}>(.*?)</${needle}>`, "g");
      result = result.replace(regex, (_, needleValue: string) => {
        return renderFn(needleValue);
      });
    }

    return result;
  };
}
